module.exports = __webpack_public_path__ + "assets/img/lsfx.9e549a88.png";